module.exports = __webpack_public_path__ + "img/layout-text-window.058d46be.svg";